import api from './interceptor';

const BASE_URL_V2 = 'api/v2/clinic-metrics';

export default {
  // API Version 2
  getSaving: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/savings`, { params }),
  getAnnualUtilization: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/annual-utilization`, { params }),
  getAverageResponse: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/average-response-time`, { params }),
  getConsultTime: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/average-consult-time`, { params }),
  getRegistrations: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/registrations`, { params }),
  getDiagnosis: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/diagnosis`, { params }),
  getTopICD: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/top-icd`, { params }),
  getDispositions: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/dispositions`, { params }),
  getAppointmentsByUserType: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/appointments-by-user-type`, { params }),
  getAppointmentsByState: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/appointments-by-state`, { params }),
  getAnnualUtilizationTrends: (clinicID, params) => api.get(`${BASE_URL_V2}/${clinicID}/annual-utilization-trends`, { params }),
};
